'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialFoursquareOutline = function IoSocialFoursquareOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.1 12.8c-0.9 4.7-2 10.2-2.1 10.8z m-1.6-10.3c2.7 0 3.5 1.6 2.8 4.5-0.2 1.2-0.7 3.4-1.2 5.8l-2.1 10.7c-0.2 1-0.6 2.7-3.1 2.7h-5.6c-0.2 0-0.2 0-0.5 0.3-0.1 0.1-8.9 10.4-8.9 10.4-0.7 0.8-1.8 0.6-2.2 0.4s-1.2-0.6-1.2-2v-29.7s0.8-3.1 3.4-3.1h18.6z m-0.1 5c0.4-2.4 0.4-2.5-1.9-2.5h-15.2c-2.3 0-2.3 0.2-2.3 2.2v23.2c0 3 0.1 3 0.2 3s0.8-0.7 2.3-2.5c0 0 6.1-6.9 6.2-7 0.1-0.1 0.2-0.1 0.4-0.1h4.9c2 0 2.2-0.5 2.6-2.5 0.3-1.6 2.8-13.8 2.8-13.8z m1.7 5.3c0.5-2.4 1-4.6 1.2-5.8z m-5.4-5.3c0.4 0 0.7 0.4 0.6 0.9l-0.6 3.4c-0.1 0.3-0.5 0.7-0.9 0.7h-5.8c-0.6 0-0.6 0.4-0.6 1v0.5c0 0.6 0 1 0.6 1h5s0.8 0.5 0.8 0.9-0.9 4-1 4.3-0.3 0.7-0.8 0.7h-4.9c-0.7 0-0.8 0-1.3 0.6l-4.2 4.9c-0.1 0.1-0.1 0.1-0.1 0v-18c0-0.4 0.4-0.9 0.9-0.9h12.3z' })
        )
    );
};

exports.default = IoSocialFoursquareOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-foursquare-outline.js
// module id = 2468
// module chunks = 0